import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../../utils/api';

// Create an API thunk for fetching data
export const fetchAllScheduledJobs = createApi('api/admin/scheduledJobs', 'GET');

const GetScheduledJobs = createSlice({
  name: 'GetScheduledJobs',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllScheduledJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllScheduledJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAllScheduledJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetScheduledJobs.reducer;